import { render, staticRenderFns } from "./OutrightsResults.vue?vue&type=template&id=72dab552"
import script from "./OutrightsResults.vue?vue&type=script&lang=js"
export * from "./OutrightsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports